export default "__VITE_ASSET__jJO5N8qj__"